import React from 'react';
import PptxGenJS from 'pptxgenjs';
import firstSlideLogo from '../assets/First Slide Logo 2.png'; 
import firstSlideShield from '../assets/First slide shield.png';

const ImageryPerceptionsPPTX = ({ possibleForYouData, easyToDealWithData, respondsToWhatYouNeedData, newWaysToDoThingsData, supportsYourAspirationsData, isTrustWorthyData, usesTechnologyData, leaderInPersonalBankingData, leadingOrganisationData, productsAndOpportunitiesData, valuablePartnerData, drivesSAGrowthData, isConfidentData, motivatesYouToGrowMoreData, understandsYouData }) => { 

  const createSlide = (pptx, title, data) => {
    if (!data || data.length === 0) {
      console.error(`No data available for slide: ${title}`);
      return;
    }

    const slide = pptx.addSlide();
    
    // Extract years and bank data
    const years = data.map(item => item.Year);
    const absaData = data.map(item => item.bank_data.Absa);
    const capitecData = data.map(item => item.bank_data.Capitec);
    const fnbData = data.map(item => item.bank_data.FNB);
    const nedbankData = data.map(item => item.bank_data.Nedbank);
    const standardBankData = data.map(item => item.bank_data['Standard Bank']);
    const tymeBankData = data.map(item => item.bank_data.TymeBank);

    // Add the title for the slide
    slide.addText(title, {
      x: 'center', y: 0.8, fontSize: 24, color: '#4682b4', bold: true, align: 'center', fontFace: 'Segoe UI'
    });

    // Add the chart
    slide.addChart(pptx.ChartType.line, [
      { name: 'Absa', labels: years, values: absaData, lineSize: 2, color: '#C8102E' },
      { name: 'Capitec', labels: years, values: capitecData, lineSize: 3, color: '#E75480' },
      { name: 'FNB', labels: years, values: fnbData, lineSize: 2, color: '#003876' },
      { name: 'Nedbank', labels: years, values: nedbankData, lineSize: 2, color: '#005941' },
      { name: 'Standard Bank', labels: years, values: standardBankData, lineSize: 2, color: '#0473EA' },
      { name: 'TymeBank', labels: years, values: tymeBankData, lineSize: 2, color: '#f4ca16' }
    ], {
      x: 0.5, y: 1.5, w: 9, h: 4, 
      showLegend: true,
      legendPos: 'b',
      legendColor: '000000',
      legendFontSize: 12,
      title: 'Total',
      titleFontSize: 28,
      titleAlign: 'center',
      showValue: true,
      dataLabelFontFace: 'Verdana',
      dataLabelFontSize: 12,
      dataLabelColor: '#FFFFFF',
      dataLabelPosition: 'ctr',
      dataLabelPlacement: 't',
      majorGridline: false,
      valAxisHidden: true,
      catAxisHidden: false,
      lineDataSymbol: 'square',
      lineDataSymbolSize: 20,
      valGridLine: { style: "none" },
      chartColors: ['#C8102E', '#E75480', '#003876', '#005941', '#0473EA', '#f4ca16']
    });
  };

  const generatePowerPoint = () => {
    const pptx = new PptxGenJS();

    // Slide 1 - Title Slide
    const slide1 = pptx.addSlide();
    slide1.addShape(pptx.ShapeType.rect, {
      x: 0, y: 0, w: '100%', h: '100%',
      fill: { color: '#0039a6' }
    });
    slide1.addImage({ path: firstSlideLogo, x: 0.4, y: 0.3, w: 4, h: 1.2 });
    slide1.addText('IMAGERY PERCEPTIONS', { x: 0.5, y: 2.5, fontSize: 35, color: '#FFFFFF' });
    slide1.addText('PERSONAL &', { x: 0.5, y: 3, fontSize: 35, color: '#ADD8E6' });
    slide1.addText('PRIVATE BANKING (PPB)', { x: 0.5, y: 3.5, fontSize: 35, color: '#ADD8E6' });
    slide1.addText('2017 - 2024 Results', { x: 0.5, y: 4.5, fontSize: 30, color: '#FFFFFF' });
    slide1.addImage({ path: firstSlideShield, x: 6.5, y: 0.7, w: 3, h: 4 });

    // Data Sets and Titles for Each Slide
    const datasets = [
      { title: 'Speaks of what could be possible for you', data: possibleForYouData },
      { title: 'Easy to deal with', data: easyToDealWithData },
      { title: 'Responds to what you need', data: respondsToWhatYouNeedData },
      { title: 'Finds new ways to do things', data: newWaysToDoThingsData },
      { title: 'Supports your aspirations', data: supportsYourAspirationsData },
      { title: 'Is trustworthy', data: isTrustWorthyData },
      { title: 'Uses technology to make banking easier', data: usesTechnologyData },
      { title: 'Is a leader in personal banking in SA', data: leaderInPersonalBankingData },
      { title: 'Is a leading organisation', data: leadingOrganisationData },
      { title: 'Offers relevant products and opportunities', data: productsAndOpportunitiesData },
      { title: 'Is a valuable partner', data: valuablePartnerData },
      { title: 'Is a bank that drives SA growth', data: drivesSAGrowthData },
      { title: 'Is confident', data: isConfidentData },
      { title: 'Motivates you to want to grow more', data: motivatesYouToGrowMoreData },
      { title: 'Understands you and what matters to you', data: understandsYouData },
    ];

    // Generate Slides for Each Data Set
    datasets.forEach(({ title, data }) => {
      createSlide(pptx, title, data);
    });

    // Save PowerPoint File
    pptx.writeFile({ fileName: 'Imagery Perceptions Presentation.pptx' });
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '2vh auto', width: '50%' }}>
      <button onClick={generatePowerPoint}>Download PowerPoint</button>
    </div>
  );
};

export default ImageryPerceptionsPPTX;
